//
//
//
//
//
//

import checkCode from "@/components/53.WechatBind/checkCode";
import "@/static/css/reset.css";
import "@/static/css/global.css";
export default {
  components: {
    checkCode,
    datainfo:""
  },
  data() {
    return {
      url:"",
      datainfor:"",
      bdOpenId: "",
      brandOpenId: "",
      oaOpenId: "",
      backUrl: "",

      info: {
        Mobile: "",
        code: "",
        activityOpenId: "",
        shopOpenId: "",
        userInfo: {
          avatar: "",
          name: "",
          BrandImg: "",
          BrandName: ""
        },
        centerImg: require("@/assets/images/24_06.png"),
        mainColor: "#fff",
        activityName: "",
        shopName: ""
      },
      dataInfo: ""
    };
  },
  created() {
    this.brandOpenId = this.$route.query.bdOpenId;
    this.bdOpenId = this.$route.query.bdOpenId;
    this.oaOpenId = this.$route.query.oaOpenId;
    this.backUrl = this.$route.query.backUrl;
    console.log(this.brandOpenId, "参数1111");

    // setTimeout(res => {
    //   this.getShopInfo();
    // }, 500);
  },
  methods: {
    getShopInfo() {
      this.$msg.loading();
      this.$http({
        url:
          "/YslMisApi/Wechat/GetFansBrandImgesInfo?brandOpenId=" +
          this.brandOpenId +
          "&oaOpenId=" +
          this.oaOpenId +
          "&bdOpenId=" +
          this.bdOpenId,
        method: "get"
      }).then(res => {
        console.log("用户信息", res);
        // this.datainfor = res.data.data.FansHeadImgUrl
        this.$msg.hideLoading();
        if (res.data.state == 1) {
        //   alert(res.data.data.FansHeadImgUrl);
          this.info.userInfo.avatar = res.data.data.FansHeadImgUrl;
          this.info.userInfo.BrandImg = res.data.data.BrandLogo;
          return;
        }

        this.$msg.alert(res.data.msg);
      });
    },

    startBind() {
      this.$msg.loading();
      var info = this.info;
      var url =
        "/YslMisApi/Wechat/BindWechat?bdOpenId=" +
        this.bdOpenId +
        "&oaOpenId=" +
        this.oaOpenId;
      this.$http({
        method: "post",
        url: url,
        data: {
          mobile: info.Mobile,
          smsCheckCode: info.code,
          brandOpenId: this.brandOpenId,
          oaOpenId: this.oaOpenId,
          bdOpenId: this.bdOpenId,
          backUrl: this.backUrl
        }
      }).then(res => {
        this.$msg.hideLoading();
        if (res.data.state == 1) {
          console.log(res, "绑定");

          var SystemCode = res.data.data.SystemCode; //会员编号
          var homeUrl = res.data.data.homeUrl; //会员中心连接
          this.url = res.data.data.url
          window.location.href = res.data.data.url;
          // this.$router.push(
          //   "/weichatbind/bindsucess?url=" +
          //     url +
          //     "&vipCord=" +
          //     SystemCode +
          //     "&MemberCenterUrl=" +
          //     homeUrl
          // );
          return;
        }

        this.$msg.alert(res.data.msg);
      });
    }
  }
};
